import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getQueryStringValue, setQueryStringValue } from '../../utils/queryString';
import { setQuery } from '../settings/page-settings-slice';
import qs from "query-string";

interface FilterState {
    types: string[];
    tags: string[];
    filterVersion: number; 
}

const removeQueryParameter = (key: string) => {
    const values = qs.parse(window.location.search);
    delete values[key];
    const newQsValue = qs.stringify(values);
    const newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        (newQsValue ? `?${newQsValue}` : '');
    window.history.pushState({ path: newurl }, "", newurl);
};

const initialState: FilterState = {
    types: [],
    tags: [],
    filterVersion: 0,
}

const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        initializeFiltersFromUrl(state) {
            const typesFromUrl = getQueryStringValue('types');
            const tagsFromUrl = getQueryStringValue('tags');
            
            if (typesFromUrl && typeof typesFromUrl === 'string') {
                state.types = typesFromUrl.split(',').filter(t => t.trim() !== '');
            }
            
            if (tagsFromUrl && typeof tagsFromUrl === 'string') {
                state.tags = tagsFromUrl.split(',').filter(t => t.trim() !== '');
            }
            
            state.filterVersion++;
        },

        updateType(state, action: PayloadAction<string>) {
            if (!state.types.includes(action.payload)) {
                state.types.push(action.payload);
                state.filterVersion++; 
            }
            
            if (state.types.length > 0) {
                setQueryStringValue('types', state.types.join(','));
            } else {
                removeQueryParameter('types');
            }
        },

        removeType(state, action: PayloadAction<string>) {
            state.types = state.types.filter((type) => type !== action.payload);
            state.filterVersion++; 
            
            if (state.types.length > 0) {
                setQueryStringValue('types', state.types.join(','));
            } else {
                removeQueryParameter('types');
            }
        },

        updateTag(state, action: PayloadAction<string>) {
            if (!state.tags.includes(action.payload)) {
                state.tags.push(action.payload);
                state.filterVersion++; 
            }
            
            if (state.tags.length > 0) {
                setQueryStringValue('tags', state.tags.join(','));
            } else {
                removeQueryParameter('tags');
            }
        },

        removeTag(state, action: PayloadAction<string>) {
            state.tags = state.tags.filter((tag) => tag !== action.payload);
            state.filterVersion++; 
            
            if (state.tags.length > 0) {
                setQueryStringValue('tags', state.tags.join(','));
            } else {
                removeQueryParameter('tags');
            }
        },

        clearAllFilters(state) {
            state.types = [];
            state.tags = [];
            state.filterVersion++; 
            removeQueryParameter('types');
            removeQueryParameter('tags');
        },
    },
    extraReducers: (builder) => {
        // Clear filters when a new search query is set
        builder.addCase(setQuery, (state) => {
            state.types = [];
            state.tags = [];
            state.filterVersion++;
        });
    }
})

export const { updateType, removeType, updateTag, removeTag, clearAllFilters, initializeFiltersFromUrl } = filtersSlice.actions

export default filtersSlice.reducer